import { z } from 'zod';

export const equipmentTypeCreateSchema = z.object({
  label: z.string().min(1).max(120),
  setupFee: z.number().nonnegative(),
  dailyRate: z.number().nonnegative(),
  idPrefix: z.string().min(1).max(8),
  qty: z.number().int().nonnegative(),
  minDays: z.number().int().nonnegative().default(0),
  sortOrder: z.number().int().optional(),
});
export type EquipmentTypeCreate = z.infer<typeof equipmentTypeCreateSchema>;

export const equipmentTypeUpdateSchema = equipmentTypeCreateSchema.partial();
export type EquipmentTypeUpdate = z.infer<typeof equipmentTypeUpdateSchema>;

export const equipmentServiceRateCreateSchema = z.object({
  label: z.string().min(1).max(120),
  rate: z.number().nonnegative(),
  multiDate: z.boolean().default(false),
  sortOrder: z.number().int().optional(),
});
export type EquipmentServiceRateCreate = z.infer<typeof equipmentServiceRateCreateSchema>;

export const equipmentServiceRateUpdateSchema = equipmentServiceRateCreateSchema.partial();
export type EquipmentServiceRateUpdate = z.infer<typeof equipmentServiceRateUpdateSchema>;
